import { render, staticRenderFns } from "./BlockedAccess.vue?vue&type=template&id=6a972337&scoped=true"
import script from "./BlockedAccess.vue?vue&type=script&lang=js"
export * from "./BlockedAccess.vue?vue&type=script&lang=js"
import style0 from "./BlockedAccess.vue?vue&type=style&index=0&id=6a972337&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a972337",
  null
  
)

export default component.exports